<div class="kt-header__topbar">

    <app-header-product-search class="kt-header__topbar-item"></app-header-product-search>

    <div class="kt-header__topbar-item d-flex align-items-center justify-content-center">
        <button type="button" id="my-custom-intercom-button" class="ia-topbar-action"
          title="Chat with support" aria-label="Chat with support">
          <i class="la la-comments" aria-hidden="true"></i>
        </button>
      </div>

    <div *ngIf="hasSyncAlerts" class="kt-header__topbar-item d-flex align-items-center">
        <div class="kt-header__topbar-wrapper" data-offset="10px,0px">
            <button type="button" mat-fab class="sync-alerts-fab" [matMenuTriggerFor]="syncAlerts" aria-label="Store sync alerts" title="Store Sync Alerts">
                <i class="flaticon-warning fs-4 text-white"></i>
                <span class="kt-badge kt-badge--danger kt-badge--dot sync-alerts-dot"></span>
            </button>
        </div>
        <mat-menu #syncAlerts="matMenu" yPosition="below" class="sync-alerts-menu">
            <div *ngIf="storesNotSynching" class="alert alert-warning sync-alerts-item" role="alert"
                (click)="$event.stopPropagation()">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">
                    The Following Stores Are Not Syncing. {{storesNotSynching}}
                    <a class="strong alert-text kt-margin-l-10" [routerLink]="['/','settings', 'sellingchannels']">Go To
                        Selling Channels</a>
                </div>
            </div>
            <div *ngIf="walmartSellerStoresMissingRefreshToken" class="alert alert-warning sync-alerts-item"
                role="alert" (click)="$event.stopPropagation()">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">
                    The Following Walmart Seller Stores Are Missing Authorization (Refresh Token).
                    {{walmartSellerStoresMissingRefreshToken}}
                    <a class="strong alert-text kt-margin-l-10" [routerLink]="['/','settings', 'sellingchannels']">Go To
                        Selling Channels</a>
                </div>
            </div>
            <div *ngIf="walmartSellerStoresRefreshTokenExpiring" class="alert alert-warning sync-alerts-item"
                role="alert" (click)="$event.stopPropagation()">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">
                    The Following Walmart Seller Stores Have Authorization (Refresh Token) Expired Or Expiring Within
                    15 Days. {{walmartSellerStoresRefreshTokenExpiring}}
                    <a class="strong alert-text kt-margin-l-10" [routerLink]="['/','settings', 'sellingchannels']">Go To
                        Selling Channels</a>
                </div>
            </div>
            <div *ngFor="let alert of fixedStockLowStockAlerts" class="alert alert-warning sync-alerts-item"
                role="alert" (click)="$event.stopPropagation()">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">
                    <ng-container *ngIf="alert.alertType === lowStockEmailAlertType.AlertOnlyProductLowStock; else favoriteStoreLowStockAlert">
                        {{alert.sku}} total warehouse inventory is at or below the alert-only reorder threshold of {{alert.thresholdLevel | number}} units (current: {{alert.currentQuantity | number}}).
                    </ng-container>
                    <ng-template #favoriteStoreLowStockAlert>
                        {{alert.sku}} favorite-store inventory uploaded is at or below the favorite-store reorder threshold of {{alert.thresholdLevel | number}} units (current: {{alert.currentQuantity | number}}).
                    </ng-template>
                    <a class="strong alert-text kt-margin-l-10" [routerLink]="['/products']" [queryParams]="{overview: 'low-stock-items'}">View low stock</a>
                    <button type="button" class="btn btn-sm btn-secondary ml-2" (click)="dismissFixedStockLowStockAlert(alert, $event)">Dismiss</button>
                </div>
            </div>
        </mat-menu>
    </div>

    <app-account-menu class="kt-header__topbar-item" [userName]="userFullName" (signedOut)="signOut()"></app-account-menu>

</div>
